import React from "react";
import { Typography } from "@mui/material";
import MeetingRoomOutlinedIcon from "@mui/icons-material/MeetingRoomOutlined";
import CustomTooltip from "../../../../Reuse/UI/CustomTooltip";
import StyleStack from "../../../../Reuse/UI/StyleStack";
import { useDoorUIState } from "./hooks/useDoorUIState";

const DoorUI = React.memo((props) => {
  const {
    value = 0,
    status = "Doors",
    clickBox = null,
    boxValue = null,
    showEmpty = false,
    tooltip = "",
  } = props;

  const { color, borderColor, background, cursor } = useDoorUIState({
    status,
    clickBox,
    boxValue,
  });

  const shouldRender = value > 0 || showEmpty;

  if (!shouldRender) return null;

  const handleClick = (e) => {
    e.preventDefault();
    if (clickBox) {
      clickBox(status);
    }
  };

  return (
    <CustomTooltip title={tooltip} placement="top">
      <StyleStack
        direction="row"
        sx={{
          border: "1px solid",
          borderColor,
          padding: 0.5,
          paddingRight: 1.25,
          gap: 0.5,
          alignItems: "center",
          cursor,
          background,
        }}
        onClick={handleClick}
      >
        <MeetingRoomOutlinedIcon sx={{ color, fontSize: 16 }} />
        <Typography variant="subtitle2" sx={{ color }}>
          {value}
        </Typography>
      </StyleStack>
    </CustomTooltip>
  );
});

export default DoorUI;